<template>
  <section>
    <v-dialog persistent v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title primary-title class="headline primary">
          <span class="title font-weight-light white--text">
            Reset Password for
            <b>{{ userName }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex xs9 md9 pt-4>
              <v-text-field
                :error-messages="error"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                prepend-inner-icon="lock"
                :type="showPassword ? 'text' : 'password'"
                v-model="newPassword"
                label="New Password"
                @input="error = ''"
                @click:append="showPassword = !showPassword"
              
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="handleCancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="resetPassword()">Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">
      <v-layout justify-center>{{ snackbarMessage }}</v-layout>
    </v-snackbar>
  </section>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "reset_password",
  components: {},
  props: {
    show: Boolean,
    userID: 0,
    userName: String
  },
  data: function() {
    return {
      showDialog: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      showPassword: false,
      error: null,
      newPassword: ""
    };
  },
  methods: {
    resetPassword: async function() {
      if (!this.error) {
        if (this.newPassword && this.newPassword.trim() != "") {
          let self = this;
          let url = `${this.$store.state.apiUrl}/customer/resetPassword`;

          axios({
            url: url,
            method: "post",
            params: {
              id: this.userID,
              newPassword: this.newPassword
            }
          })
            .then(function(response) {
              if (response.data.error == "no_error") {
                self.snackbarMessage = "Password successfully updated";
                self.snackbarColour = "success";
                self.snackbarShow = true;
              } else {
                self.snackbarMessage =
                  "Error updating password: " + response.data.error;
                self.snackbarColour = "error";
                self.snackbarShow = true;
                console.log(response.data.error);
              }
              self.showDialog = false;
            })
            .catch(function(error) {
              self.snackbarMessage = "Error updating password: " + error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(error);
              self.showDialog = false;
            });
        } else {
          this.error = "New password must be provided";
        }
      }
    },
    handleCancel: function() {
      this.newPassword = "";
      this.error = null;
      this.showDialog = false;
    }
  },
  watch: {
    showDialog: function() {
      if (this.showDialog == false) {
        this.$emit("hideResetPassword");
      }
    },
    show: function() {
      this.showDialog = this.show;
    }
  }
};
</script>
